import { combineReducers } from 'redux';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import menuStore, { menuStorePersistWhitelist } from './menu/duck';
import schedulingStore, { schedulingStorePersistWhitelist } from './scheduling/duck';
import reservationsStore, { reservationsStorePersistWhitelist } from './reservations/duck';

const menuPersistConfig = {
  key: 'menuStore',
  storage,
  whitelist: menuStorePersistWhitelist,
};

const schedulingPersistConfig = {
  key: 'schedulingStore',
  storage,
  whitelist: schedulingStorePersistWhitelist,
};

const reservationsPersistConfig = {
  key: 'reservationsStore',
  storage,
  whitelist: reservationsStorePersistWhitelist,
};

const rootReducer = combineReducers({
  menu: persistReducer(menuPersistConfig, menuStore),
  scheduling: persistReducer(schedulingPersistConfig, schedulingStore),
  reservations: persistReducer(reservationsPersistConfig, reservationsStore),
});

export default rootReducer;
